import { RowsPerPageAPI } from '../api/row-per-page.api';
import { RowsPerPage } from '../model/row-per-page.model';

export const mapRowPerPageApiToModel = ({ devices, trainings, operators }: RowsPerPageAPI): RowsPerPage => ({
    devices,
    trainings,
    operators,
});
